import { Flex, Typography } from '@flex-design-system/fx';
import { styled } from '@flex-design-system/stitches-react';
import { Translation } from '@flex-packages/i18n';
import { Fragment } from 'react';

import type { LocalizedTerm, TermGroup } from './constants';

interface Props {
  termGroup: TermGroup;
  required?: boolean;
}

const TermText = ({ term }: { term: LocalizedTerm }) => {
  return <Translation tKey={term.tKey} tOptions={term.tOptions} />;
};

export function TermsGroupContainer({ termGroup, required = false }: Props) {
  return (
    <Flex direction="column" css={{ gap: 12 }}>
      <TermTitle>
        <TermText term={termGroup.title} />
        {required ? <RequiredDot /> : null}
      </TermTitle>
      <TextAreaLikeText color="gray">
        {termGroup.description && <TermText term={termGroup.description} />}
        {termGroup.description && termGroup.terms.length > 0 && (
          <>
            <br />
            <br />
          </>
        )}
        {termGroup.terms.map((termList, groupIndex) => (
          <Fragment key={groupIndex}>
            <TermText term={termList.title} />
            <TermList>
              {termList.items.map((item, listIndex) => (
                <TermListItem key={listIndex}>
                  <TermText term={item} />
                </TermListItem>
              ))}
            </TermList>
          </Fragment>
        ))}
      </TextAreaLikeText>
    </Flex>
  );
}

const TextAreaLikeText = styled(Typography, {
  px: 18,
  py: 12,
  borderRadius: 8,
  boxShadow: '$inputOutline',
  fontSize: 12,
  lineHeight: 1.5,

  maxHeight: 200,
  overflowY: 'auto',
});

const TermList = styled('ul', {
  marginLeft: 8,
  marginTop: 4,
  listStyleType: 'dics',
  listStylePosition: 'inside',

  '&:not(:last-child)': {
    marginBottom: 32,
  },
});

const TermListItem = styled('li', {
  listStyleType: 'disc',
});

const TermTitle = styled('div', {
  fontSize: 15,
  lineHeight: 1.4,
  fontWeight: 600,
  color: '$grayDark',
});

const RequiredDot = styled('span', {
  display: 'inline-block',
  width: 3,
  height: 3,
  marginTop: 2,
  marginLeft: 2,
  verticalAlign: 'top',
  borderRadius: '50%',
  backgroundColor: '$orangeLight',
});
